import { useEffect } from "react";

// Injects a JSON-LD <script> into <head> and cleans up on unmount.
export const JsonLd = ({ data, id }) => {
  useEffect(() => {
    const key = id || `jsonld-${Math.random().toString(36).slice(2)}`;
    let el = document.getElementById(key);
    if (!el) {
      el = document.createElement("script");
      el.type = "application/ld+json";
      el.id = key;
      document.head.appendChild(el);
    }
    el.textContent = JSON.stringify(data);
    return () => {
      const node = document.getElementById(key);
      if (node) node.remove();
    };
  }, [data, id]);
  return null;
};
